module.exports = __webpack_public_path__ + "img/facial_hair_full_beard_thin_extra_heart_mask.74f26d13.png";